import { Step, StepButton, Stepper } from '@mui/material';

import { useFormContext } from '#form';

export function PageStepper<Page extends string>({
	navigateToPage,
	page,
	options,
}: {
	navigateToPage: (destination: Page) => void;
	page: Page;
	options: { [k in Page]: string };
}) {
	const form = useFormContext();
	return (
		<form.Subscribe selector={(state) => [state.isSubmitting] as const}>
			{([isSubmitting]) => {
				function submit(destination: Page) {
					if (!isSubmitting) {
						navigateToPage(destination);
					}
				}

				const pages = Object.keys(options) as Page[];

				return (
					<Stepper nonLinear activeStep={pages.indexOf(page)} sx={{ my: 1 }}>
						{pages.map((page) => (
							<Step key={page}>
								<StepButton
									onClick={() => {
										submit(page);
									}}
								>
									{options[page]}
								</StepButton>
							</Step>
						))}
					</Stepper>
				);
			}}
		</form.Subscribe>
	);
}
